import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPreRound1Disagreementv2 extends BaseLayer {

    id = "stitchPreRound1Disagreementv2";
    label = "Before";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPreR1Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPreR1Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPreRound1Disagreementv2;
